import { render, staticRenderFns } from "./locations.vue?vue&type=template&id=2b9be0bf&scoped=true"
import script from "./locations.vue?vue&type=script&lang=js"
export * from "./locations.vue?vue&type=script&lang=js"
import style0 from "./locations.vue?vue&type=style&index=0&id=2b9be0bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9be0bf",
  null
  
)

export default component.exports